/* global axios */
import ApiClient from './ApiClient';

class FollowUpFlowsAPI extends ApiClient {
  constructor() {
    super('follow_up_flows', { accountScoped: true });
  }

  getFlows() {
    return axios.get(this.url);
  }

  getFlow(flowId) {
    return axios.get(`${this.url}/${flowId}`);
  }

  createFlow(flowData) {
    return axios.post(this.url, { follow_up_flow: flowData });
  }

  updateFlow(flowId, flowData) {
    return axios.patch(`${this.url}/${flowId}`, { follow_up_flow: flowData });
  }

  activateFlow(flowId) {
    return axios.post(`${this.url}/${flowId}/activate`);
  }

  pauseFlow(flowId) {
    return axios.post(`${this.url}/${flowId}/pause`);
  }

  resumeFlow(flowId) {
    return axios.post(`${this.url}/${flowId}/resume`);
  }

  archiveFlow(flowId) {
    return axios.post(`${this.url}/${flowId}/archive`);
  }

  deleteFlow(flowId) {
    return axios.delete(`${this.url}/${flowId}`);
  }

  enrollContacts(flowId, contactIds) {
    return axios.post(`${this.url}/${flowId}/enroll_contacts`, {
      contact_ids: contactIds,
    });
  }

  getEnrollmentRun(flowId, runId, { after } = {}) {
    return axios.get(`${this.url}/${flowId}/enrollment_runs/${runId}`, {
      params: after ? { after } : {},
    });
  }

  getEnrollmentRuns(flowId) {
    return axios.get(`${this.url}/${flowId}/enrollment_runs`);
  }

  getAnalytics(flowId) {
    return axios.get(`${this.url}/${flowId}/analytics`);
  }

  getAnalyticsEnrollments(flowId, params = {}) {
    return axios.get(`${this.url}/${flowId}/analytics/enrollments`, {
      params,
    });
  }

  exportAnalytics(flowId) {
    return axios.get(`${this.url}/${flowId}/analytics/export`, {
      responseType: 'blob',
    });
  }
}

export default new FollowUpFlowsAPI();
